export default __webpack_public_path__ + "media/images/chefs-2-8da602871169c8ef4016afb7098a712e.png";